var o = Function.prototype, e = o.toString;
function n(t) {
  if (t != null) {
    try {
      return e.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var c = n;
export {
  c as default
};
//# sourceMappingURL=_toSource.js.map
